export default __webpack_public_path__ + "static/media/713.46ffc1d1.svg";